// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CalendarStyles.css */

/* Set toolbar text color to white */
.custom-calendar .rbc-toolbar-label,
.custom-calendar .rbc-btn-group button {
  /* color: rgb(187, 187, 187); */
  color: rgb(122, 122, 122);
  font-size: medium;
  font-family: 'poppins', sans-serif;
}

/* Optional: Add hover effect for buttons */
.custom-calendar .rbc-btn-group button:hover {
  background-color: #555;
  color: white;
}

/* Style the day cells for a better look */
.custom-calendar .rbc-month-view .rbc-date-cell {
  color: rgb(178, 178, 178);
}

/* Today’s date highlight */
.custom-calendar .rbc-today {
  background-color: hsl(0, 0%, 26%); /* blue color for today's date */
}

/* Event colors */
.custom-calendar .rbc-event {
  /* background-color: #d37800; Coral for events */
  background-color: #d2fc61; /* Coral for events */
  opacity: calc(0.9);
  border: none; /* Remove default border */
  color: rgb(23, 23, 23); /* Text color for events */
}

/* Change shell color for next month days */
.custom-calendar .rbc-off-range-bg {
  /* background-color: #464646; */
  background-color: hsl(0, 0%, 6%);
}

/* Change all grid lines in the react-big-calendar to red */

/* General border style for different calendar views */
.custom-calendar .rbc-time-view .rbc-time-header-cell,
.custom-calendar .rbc-time-view .rbc-time-content,
.custom-calendar .rbc-time-content > .rbc-time-grid > .rbc-time-column,
.custom-calendar .rbc-day-slot .rbc-timeslot-group,
.custom-calendar .rbc-time-column .rbc-timeslot-group,
.custom-calendar .rbc-timeslot-group,
.custom-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td,
.custom-calendar .rbc-day-bg,
.custom-calendar .rbc-month-view .rbc-row,
.custom-calendar .rbc-month-view .rbc-month-row,
.custom-calendar .rbc-month-view .rbc-header,
.custom-calendar .rbc-month-view .rbc-header + .rbc-header,
.custom-calendar .rbc-day-slot .rbc-timeslot-group {
  border-color: rgb(41, 41, 41) !important; /* Change all borders to red */
}

/* Month view specific styles */
.custom-calendar .rbc-month-view .rbc-day-bg + .rbc-day-bg,
.custom-calendar .rbc-month-view .rbc-date-cell,
.custom-calendar .rbc-month-view .rbc-header {
  border-right: 1px solid rgb(87, 87, 87); /* Red grid lines in month view */
}

/* Weekly view time grid slot styles */
.custom-calendar .rbc-time-grid .rbc-timeslot-group {
  border-bottom: 1px solid rgb(110, 110, 110); /* Red grid lines in week/day view */
}

/* Agenda view table border styles */
.custom-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr {
  border-bottom: 1px solid rgb(99, 99, 99); /* Red grid lines for agenda view */
}

/* Agenda view table text color */
.custom-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  color: rgb(186, 186, 186); /* Change agenda view text color to red */
}

/* Optional: You can also target the header if needed */
.custom-calendar .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  color: rgb(209, 208, 208); /* Change agenda view header text color to red */
}
`, "",{"version":3,"sources":["webpack://./src/components/EventCalender/CalenderStyle.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB,oCAAoC;AACpC;;EAEE,+BAA+B;EAC/B,yBAAyB;EACzB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA,2CAA2C;AAC3C;EACE,sBAAsB;EACtB,YAAY;AACd;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,iCAAiC,EAAE,gCAAgC;AACrE;;AAEA,iBAAiB;AACjB;EACE,gDAAgD;EAChD,yBAAyB,EAAE,qBAAqB;EAChD,kBAAkB;EAClB,YAAY,EAAE,0BAA0B;EACxC,sBAAsB,EAAE,0BAA0B;AACpD;;AAEA,2CAA2C;AAC3C;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,2DAA2D;;AAE3D,sDAAsD;AACtD;;;;;;;;;;;;;EAaE,wCAAwC,EAAE,8BAA8B;AAC1E;;AAEA,+BAA+B;AAC/B;;;EAGE,uCAAuC,EAAE,iCAAiC;AAC5E;;AAEA,sCAAsC;AACtC;EACE,2CAA2C,EAAE,oCAAoC;AACnF;;AAEA,oCAAoC;AACpC;EACE,wCAAwC,EAAE,mCAAmC;AAC/E;;AAEA,iCAAiC;AACjC;EACE,yBAAyB,EAAE,yCAAyC;AACtE;;AAEA,uDAAuD;AACvD;EACE,yBAAyB,EAAE,gDAAgD;AAC7E","sourcesContent":["/* CalendarStyles.css */\n\n/* Set toolbar text color to white */\n.custom-calendar .rbc-toolbar-label,\n.custom-calendar .rbc-btn-group button {\n  /* color: rgb(187, 187, 187); */\n  color: rgb(122, 122, 122);\n  font-size: medium;\n  font-family: 'poppins', sans-serif;\n}\n\n/* Optional: Add hover effect for buttons */\n.custom-calendar .rbc-btn-group button:hover {\n  background-color: #555;\n  color: white;\n}\n\n/* Style the day cells for a better look */\n.custom-calendar .rbc-month-view .rbc-date-cell {\n  color: rgb(178, 178, 178);\n}\n\n/* Today’s date highlight */\n.custom-calendar .rbc-today {\n  background-color: hsl(0, 0%, 26%); /* blue color for today's date */\n}\n\n/* Event colors */\n.custom-calendar .rbc-event {\n  /* background-color: #d37800; Coral for events */\n  background-color: #d2fc61; /* Coral for events */\n  opacity: calc(0.9);\n  border: none; /* Remove default border */\n  color: rgb(23, 23, 23); /* Text color for events */\n}\n\n/* Change shell color for next month days */\n.custom-calendar .rbc-off-range-bg {\n  /* background-color: #464646; */\n  background-color: hsl(0, 0%, 6%);\n}\n\n/* Change all grid lines in the react-big-calendar to red */\n\n/* General border style for different calendar views */\n.custom-calendar .rbc-time-view .rbc-time-header-cell,\n.custom-calendar .rbc-time-view .rbc-time-content,\n.custom-calendar .rbc-time-content > .rbc-time-grid > .rbc-time-column,\n.custom-calendar .rbc-day-slot .rbc-timeslot-group,\n.custom-calendar .rbc-time-column .rbc-timeslot-group,\n.custom-calendar .rbc-timeslot-group,\n.custom-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td,\n.custom-calendar .rbc-day-bg,\n.custom-calendar .rbc-month-view .rbc-row,\n.custom-calendar .rbc-month-view .rbc-month-row,\n.custom-calendar .rbc-month-view .rbc-header,\n.custom-calendar .rbc-month-view .rbc-header + .rbc-header,\n.custom-calendar .rbc-day-slot .rbc-timeslot-group {\n  border-color: rgb(41, 41, 41) !important; /* Change all borders to red */\n}\n\n/* Month view specific styles */\n.custom-calendar .rbc-month-view .rbc-day-bg + .rbc-day-bg,\n.custom-calendar .rbc-month-view .rbc-date-cell,\n.custom-calendar .rbc-month-view .rbc-header {\n  border-right: 1px solid rgb(87, 87, 87); /* Red grid lines in month view */\n}\n\n/* Weekly view time grid slot styles */\n.custom-calendar .rbc-time-grid .rbc-timeslot-group {\n  border-bottom: 1px solid rgb(110, 110, 110); /* Red grid lines in week/day view */\n}\n\n/* Agenda view table border styles */\n.custom-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr {\n  border-bottom: 1px solid rgb(99, 99, 99); /* Red grid lines for agenda view */\n}\n\n/* Agenda view table text color */\n.custom-calendar .rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  color: rgb(186, 186, 186); /* Change agenda view text color to red */\n}\n\n/* Optional: You can also target the header if needed */\n.custom-calendar .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  color: rgb(209, 208, 208); /* Change agenda view header text color to red */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
